import * as t from "./actionType";

// ---------- wifiaccesspoint (AP) ----------
export const wifiApList = (data) => ({ type: t.WIFI_AP_LIST, data });
export const wifiApListSuccess = (data) => ({ type: t.WIFI_AP_LIST_SUCCESS, data });
export const wifiApListFail = (data) => ({ type: t.WIFI_AP_LIST_FAIL, data });

export const wifiApData = (data) => ({ type: t.WIFI_AP_DATA, data });
export const wifiApDataSuccess = (data) => ({ type: t.WIFI_AP_DATA_SUCCESS, data });
export const wifiApDataFail = (data) => ({ type: t.WIFI_AP_DATA_FAIL, data });

export const wifiApCreate = (data) => ({ type: t.WIFI_AP_CREATE, data });
export const wifiApCreateSuccess = (data) => ({ type: t.WIFI_AP_CREATE_SUCCESS, data });
export const wifiApCreateFail = (data) => ({ type: t.WIFI_AP_CREATE_FAIL, data });
export const wifiApCreateReset = () => ({ type: t.WIFI_AP_CREATE_RESET });

export const wifiApUpdate = (data) => ({ type: t.WIFI_AP_UPDATE, data });
export const wifiApUpdateSuccess = (data) => ({ type: t.WIFI_AP_UPDATE_SUCCESS, data });
export const wifiApUpdateFail = (data) => ({ type: t.WIFI_AP_UPDATE_FAIL, data });
export const wifiApUpdateReset = () => ({ type: t.WIFI_AP_UPDATE_RESET });

export const wifiApDelete = (data) => ({ type: t.WIFI_AP_DELETE, data });
export const wifiApDeleteSuccess = (data) => ({ type: t.WIFI_AP_DELETE_SUCCESS, data });
export const wifiApDeleteFail = (data) => ({ type: t.WIFI_AP_DELETE_FAIL, data });
export const wifiApDeleteReset = () => ({ type: t.WIFI_AP_DELETE_RESET });

// ---------- wifiportalguestprofile (PROFILE) ----------
export const wifiProfileList = (data) => ({ type: t.WIFI_PROFILE_LIST, data });
export const wifiProfileListSuccess = (data) => ({ type: t.WIFI_PROFILE_LIST_SUCCESS, data });
export const wifiProfileListFail = (data) => ({ type: t.WIFI_PROFILE_LIST_FAIL, data });

export const wifiProfileData = (data) => ({ type: t.WIFI_PROFILE_DATA, data });
export const wifiProfileDataSuccess = (data) => ({ type: t.WIFI_PROFILE_DATA_SUCCESS, data });
export const wifiProfileDataFail = (data) => ({ type: t.WIFI_PROFILE_DATA_FAIL, data });

export const wifiProfileCreate = (data) => ({ type: t.WIFI_PROFILE_CREATE, data });
export const wifiProfileCreateSuccess = (data) => ({ type: t.WIFI_PROFILE_CREATE_SUCCESS, data });
export const wifiProfileCreateFail = (data) => ({ type: t.WIFI_PROFILE_CREATE_FAIL, data });
export const wifiProfileCreateReset = () => ({ type: t.WIFI_PROFILE_CREATE_RESET });

export const wifiProfileUpdate = (data) => ({ type: t.WIFI_PROFILE_UPDATE, data });
export const wifiProfileUpdateSuccess = (data) => ({ type: t.WIFI_PROFILE_UPDATE_SUCCESS, data });
export const wifiProfileUpdateFail = (data) => ({ type: t.WIFI_PROFILE_UPDATE_FAIL, data });
export const wifiProfileUpdateReset = () => ({ type: t.WIFI_PROFILE_UPDATE_RESET });

export const wifiProfileDelete = (data) => ({ type: t.WIFI_PROFILE_DELETE, data });
export const wifiProfileDeleteSuccess = (data) => ({ type: t.WIFI_PROFILE_DELETE_SUCCESS, data });
export const wifiProfileDeleteFail = (data) => ({ type: t.WIFI_PROFILE_DELETE_FAIL, data });
export const wifiProfileDeleteReset = () => ({ type: t.WIFI_PROFILE_DELETE_RESET });

// ---------- wifisitelocation (SITE) ----------
export const wifiSiteList = (data) => ({ type: t.WIFI_SITE_LIST, data });
export const wifiSiteListSuccess = (data) => ({ type: t.WIFI_SITE_LIST_SUCCESS, data });
export const wifiSiteListFail = (data) => ({ type: t.WIFI_SITE_LIST_FAIL, data });

export const wifiSiteData = (data) => ({ type: t.WIFI_SITE_DATA, data });
export const wifiSiteDataSuccess = (data) => ({ type: t.WIFI_SITE_DATA_SUCCESS, data });
export const wifiSiteDataFail = (data) => ({ type: t.WIFI_SITE_DATA_FAIL, data });

export const wifiSiteCreate = (data) => ({ type: t.WIFI_SITE_CREATE, data });
export const wifiSiteCreateSuccess = (data) => ({ type: t.WIFI_SITE_CREATE_SUCCESS, data });
export const wifiSiteCreateFail = (data) => ({ type: t.WIFI_SITE_CREATE_FAIL, data });
export const wifiSiteCreateReset = () => ({ type: t.WIFI_SITE_CREATE_RESET });

export const wifiSiteUpdate = (data) => ({ type: t.WIFI_SITE_UPDATE, data });
export const wifiSiteUpdateSuccess = (data) => ({ type: t.WIFI_SITE_UPDATE_SUCCESS, data });
export const wifiSiteUpdateFail = (data) => ({ type: t.WIFI_SITE_UPDATE_FAIL, data });
export const wifiSiteUpdateReset = () => ({ type: t.WIFI_SITE_UPDATE_RESET });

export const wifiSiteDelete = (data) => ({ type: t.WIFI_SITE_DELETE, data });
export const wifiSiteDeleteSuccess = (data) => ({ type: t.WIFI_SITE_DELETE_SUCCESS, data });
export const wifiSiteDeleteFail = (data) => ({ type: t.WIFI_SITE_DELETE_FAIL, data });
export const wifiSiteDeleteReset = () => ({ type: t.WIFI_SITE_DELETE_RESET });

export const wifiSiteUnifiTest = (data) => ({ type: t.WIFI_SITE_UNIFI_TEST, data });
export const wifiSiteUnifiTestSuccess = (data) => ({ type: t.WIFI_SITE_UNIFI_TEST_SUCCESS, data });
export const wifiSiteUnifiTestFail = (data) => ({ type: t.WIFI_SITE_UNIFI_TEST_FAIL, data });
export const wifiSiteUnifiTestReset = () => ({ type: t.WIFI_SITE_UNIFI_TEST_RESET });

export const wifiSiteUnifiSync = (data) => ({ type: t.WIFI_SITE_UNIFI_SYNC, data });
export const wifiSiteUnifiSyncSuccess = (data) => ({ type: t.WIFI_SITE_UNIFI_SYNC_SUCCESS, data });
export const wifiSiteUnifiSyncFail = (data) => ({ type: t.WIFI_SITE_UNIFI_SYNC_FAIL, data });
export const wifiSiteUnifiSyncReset = () => ({ type: t.WIFI_SITE_UNIFI_SYNC_RESET });

export const wifiSiteComoTest = (data) => ({ type: t.WIFI_SITE_COMO_TEST, data });
export const wifiSiteComoTestSuccess = (data) => ({ type: t.WIFI_SITE_COMO_TEST_SUCCESS, data });
export const wifiSiteComoTestFail = (data) => ({ type: t.WIFI_SITE_COMO_TEST_FAIL, data });
export const wifiSiteComoTestReset = () => ({ type: t.WIFI_SITE_COMO_TEST_RESET });

// ---------- wifiguestregistration (REG) ----------
export const wifiRegList = (data) => ({ type: t.WIFI_REG_LIST, data });
export const wifiRegListSuccess = (data) => ({ type: t.WIFI_REG_LIST_SUCCESS, data });
export const wifiRegListFail = (data) => ({ type: t.WIFI_REG_LIST_FAIL, data });

export const wifiRegData = (data) => ({ type: t.WIFI_REG_DATA, data });
export const wifiRegDataSuccess = (data) => ({ type: t.WIFI_REG_DATA_SUCCESS, data });
export const wifiRegDataFail = (data) => ({ type: t.WIFI_REG_DATA_FAIL, data });

export const wifiRegSearch = (data) => ({ type: t.WIFI_REG_SEARCH, data });
export const wifiRegSearchSuccess = (data) => ({ type: t.WIFI_REG_SEARCH_SUCCESS, data });
export const wifiRegSearchFail = (data) => ({ type: t.WIFI_REG_SEARCH_FAIL, data });

// ---------- wifiportalerrorlog (ERRLOG) ----------
export const wifiErrLogList = (data) => ({ type: t.WIFI_ERRLOG_LIST, data });
export const wifiErrLogListSuccess = (data) => ({ type: t.WIFI_ERRLOG_LIST_SUCCESS, data });
export const wifiErrLogListFail = (data) => ({ type: t.WIFI_ERRLOG_LIST_FAIL, data });

export const wifiErrLogData = (data) => ({ type: t.WIFI_ERRLOG_DATA, data });
export const wifiErrLogDataSuccess = (data) => ({ type: t.WIFI_ERRLOG_DATA_SUCCESS, data });
export const wifiErrLogDataFail = (data) => ({ type: t.WIFI_ERRLOG_DATA_FAIL, data });

export const wifiErrLogSearch = (data) => ({ type: t.WIFI_ERRLOG_SEARCH, data });
export const wifiErrLogSearchSuccess = (data) => ({ type: t.WIFI_ERRLOG_SEARCH_SUCCESS, data });
export const wifiErrLogSearchFail = (data) => ({ type: t.WIFI_ERRLOG_SEARCH_FAIL, data });

// ---------- wifisitelocationtowifiaccesspoint (LINK) ----------
export const wifiLinkList = (data) => ({ type: t.WIFI_LINK_LIST, data });
export const wifiLinkListSuccess = (data) => ({ type: t.WIFI_LINK_LIST_SUCCESS, data });
export const wifiLinkListFail = (data) => ({ type: t.WIFI_LINK_LIST_FAIL, data });

export const wifiLinkCreate = (data) => ({ type: t.WIFI_LINK_CREATE, data });
export const wifiLinkCreateSuccess = (data) => ({ type: t.WIFI_LINK_CREATE_SUCCESS, data });
export const wifiLinkCreateFail = (data) => ({ type: t.WIFI_LINK_CREATE_FAIL, data });
export const wifiLinkCreateReset = () => ({ type: t.WIFI_LINK_CREATE_RESET });

export const wifiLinkDelete = (data) => ({ type: t.WIFI_LINK_DELETE, data });
export const wifiLinkDeleteSuccess = (data) => ({ type: t.WIFI_LINK_DELETE_SUCCESS, data });
export const wifiLinkDeleteFail = (data) => ({ type: t.WIFI_LINK_DELETE_FAIL, data });
export const wifiLinkDeleteReset = () => ({ type: t.WIFI_LINK_DELETE_RESET });
